import { memo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import { getEndpointUrl } from "../../Utils/Common";

const DeleteChoiceDetailDialog = ({ visible, onHide, data, onSuccess }) => {
    const [isLoading, setLoading] = useState(false);
    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const onDelete = async () => {
        if (!data?.id) {
            toast.error("Data detail tidak valid.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${getEndpointUrl()}/v2/form_choice_details/${data.id}`, {
                method: "DELETE",
                headers: new Headers({
                    Authorization: `Bearer ${accesToken}`,
                }),
            });

            const json = await res.json();
            setLoading(false);

            if (json.status === 'ok') {
                toast.success("Choice detail berhasil dihapus.", {
                    position: "top-center",
                    autoClose: 2500,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
                onSuccess({
                    deleted_id: json.deleted_id,
                    affected: json.affected,
                    results: json.results
                });
                onHide();
            } else {
                toast.error(json.message || "Gagal menghapus choice detail.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        } catch (err) {
            setLoading(false);
            toast.error("Terjadi kesalahan jaringan.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        }
    };

    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={visible} onHide={onHide} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isLoading ? "Memproses..." : "Hapus Choice Detail"}
                    </Modal.Title>
                </Modal.Header>

                {isLoading ? (
                    <div className="d-flex justify-content-center mt-5 mb-5">
                        <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                    </div>
                ) : (
                    <>
                        <Modal.Body>
                            Apakah Anda yakin ingin menghapus detail pilihan:
                            <br /><strong>{data?.detail || '-'}</strong>?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onHide}>Batal</Button>
                            <Button variant="danger" onClick={onDelete}>Hapus</Button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
        </>
    );
};

export default memo(DeleteChoiceDetailDialog);